
var stateManager = require('../../state/stateManager.js');
var stringUtil = require('../../string/stringUtil.js');

module.exports.getDiscountExcludedTags = function(discountCode)
{
    var discountOffers = stateManager.getStore().getState().discountOffers;
    if (discountOffers == null) return "";
    var discountOffer = discountOffers.find (d => stringUtil.areStringSame(d.code, discountCode));
    if (discountOffer == null || stringUtil.isStringNullOrEmpty(discountOffer.paramsJson)) return "";
    var discountConfiguration = JSON.parse(discountOffer.paramsJson);
    if (discountConfiguration == null || 
        discountConfiguration.tags == null ||
        discountConfiguration.tags.exclusionTags == null) return "";

    return discountConfiguration.tags.exclusionTags;

}